import React, { useEffect } from "react";
import "./registerComponent.css";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { LoaderContext } from "../../context/LoaderContext";
import Loader from "../loader/loader";
import { API_URL } from "../../enviormentVariables";
import { Modal } from "../Modals/ModalComponent/Modal";
import ModalDividerLine from "../Modals/ModalComponent/modal-divider-line";
import { AlertContext } from "../../context/AlertContext";
import { Alert } from "../../utils/genericUtils";

function RegisterComponent() {
  const router = useNavigate();
  const { show, showloader, hideloader } = useContext(LoaderContext);
  const {globalAlert} = useContext(AlertContext)

  useEffect(() => {}, []);

  function validateFields() {
    let isValid = true;
    let firstNameInput = document.getElementById("first-name-input");
    let lastNameInput = document.getElementById("last-name-input");
    let emailInput = document.getElementById("email-input");
    let usernameInput = document.getElementById("username-input");
    let passwordInput = document.getElementById("password-input");
    let confirmPasswordInput = document.getElementById("confirm-password-input");

    if (firstNameInput.value.length < 1) {
      isValid = false;
      firstNameInput.value = "";
      firstNameInput.placeholder = "first name required";
      firstNameInput.style.border = "2px solid red";
    }

    if (lastNameInput.value.length < 1) {
      isValid = false;
      lastNameInput.value = "";
      lastNameInput.placeholder = "last name required";
      lastNameInput.style.border = "2px solid red";
    }

    if (usernameInput.value.length < 1) {
      isValid = false;
      usernameInput.value = "";
      usernameInput.placeholder = "username required";
      usernameInput.style.border = "2px solid red";
    }

    if (emailInput.value.length < 1) {
      isValid = false;
      emailInput.value = "";
      emailInput.placeholder = "email required";
      emailInput.style.border = "2px solid red";
    } else {
      // Email validation logic
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailInput.value)) {
        isValid = false;
        emailInput.value = "";
        emailInput.placeholder = "invalid email format";
        emailInput.style.border = "2px solid red";
      }
    }

    if (passwordInput.value.length < 1) {
      isValid = false;
      passwordInput.value = "";
      passwordInput.placeholder = "password required";
      passwordInput.style.border = "2px solid red";
    } else if (passwordInput.value !== confirmPasswordInput.value) {
      isValid = false;
      passwordInput.value = "";
      confirmPasswordInput.value = "";
      passwordInput.placeholder = "passwords do not match";
      confirmPasswordInput.placeholder = "passwords do not match";
      passwordInput.style.border = "2px solid red";
      confirmPasswordInput.style.border = "2px solid red";
    } else {
      if (passwordInput.value.length < 8) {
        isValid = false;
        passwordInput.value = "";
        passwordInput.placeholder = "password should be at least 8 characters";
        passwordInput.style.border = "2px solid red";
      }
    }

    // Additional validation logic for other fields can be added here

    return isValid;
  }

  /**
   * POST create a new user, if successfull will also generate a jwt and log the user in
   */
  function register() {
    if (validateFields()) {
      showloader();
      let request = new XMLHttpRequest();
      request.open("POST", API_URL + "/register");
      request.setRequestHeader("Content-Type", "application/json");
      //get inputs
      let firstName = document.getElementById("first-name-input").value;
      let lastName = document.getElementById("last-name-input").value;
      let email = document.getElementById("email-input").value;
      let username = document.getElementById("username-input").value;
      let password = document.getElementById("password-input").value;
      let newUserRequest = {
        firstName,
        lastName,
        email,
        username,
        password,
      };
      request.send(JSON.stringify(newUserRequest));
      request.onload = () => {
        hideloader();
        let response = JSON.parse(request.response);
        if (response.success) {
          //check for jwt
          if (response.jwt) {
            //save to local storage
            localStorage.setItem("jwt", response.jwt);
          }
          router(`/registration-success?id=${username}&registered=true`);
        } else {
          Alert(globalAlert, 'error', 'Error', response.error.message)
        }
      };
    }
  }

  return (
    <>
      <Loader />
      <Modal id={"register-modal"} class="register-modal" isActive={true} animate={false} header="Registration" showDivider={true}>
        <div className="paired-inputs">
          <div className="input-box">
            <label className="input-label" htmlFor="first-name-input">
              First Name
            </label>
            <input type="text" id="first-name-input" placeholder="John" />
          </div>

          <div className="input-box">
            <label className="input-label" htmlFor="last-name-input">
              Last Name
            </label>
            <input type="text" id="last-name-input" placeholder="Doe" />
          </div>
        </div>

        <ModalDividerLine showDivider={true} />

        <div className="paired-inputs">
          <div className="input-box">
            <label className="input-label" htmlFor="username-input">
              Username
            </label>
            <input type="email" id="username-input" placeholder="Username" />
          </div>

          <div className="input-box">
            <label className="input-label" htmlFor="email-input">
              Email
            </label>
            <input type="email" id="email-input" placeholder="example@email.com" />
          </div>
        </div>

        <ModalDividerLine showDivider={true} />

        <div className="input-box">
          <label className="input-label" htmlFor="password-input">
            Password
          </label>
          <input type="password" id="password-input" placeholder="Password" />
        </div>

        <div className="input-box">
          <label className="input-label" htmlFor="confirm-password-input">
            Confirm Password
          </label>
          <input type="password" id="confirm-password-input" placeholder="Confirm Password" />
        </div>

        <ModalDividerLine showDivider={true} />

        <button type="button" className="standard-button register-button" onClick={register}>
          Sign Up
        </button>

        <div className="already-have-an-account-box">
          <p>Already have an account?</p>
          <Link to={"/login"}>Login</Link>
        </div>
      </Modal>
    </>
  );
}

export default RegisterComponent;
